import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Experience } from '~/hooks/api/useExperiences';
import Spacings from '~/modules/ui-kit/spacings';
import messages from './messages';

type ExperienceDetailViewProps = {
  experience: Experience;
};

export const ExperienceDetailView = (props: ExperienceDetailViewProps) => {
  return (
    <Spacings.Stack scale="l">
      <div>
        <Typography variant="h6">{props.experience.title}</Typography>
        <div>
          {props.experience.publisher.firstName}{' '}
          {props.experience.publisher.lastName}
        </div>
        {props.experience.turn ? (
          <div>
            <FormattedMessage {...messages.shift} />:{' '}
            {moment(props.experience.turn.shift.startDate).format('ll')}{' '}
            {moment(props.experience.turn.shift.startDate).format('LT')} -{' '}
            {moment(props.experience.turn.shift.endDate).format('LT')}{' '}
            {props.experience.turn.route.name}
          </div>
        ) : null}
      </div>
      {props.experience.events.map((event) => (
        <Spacings.Stack scale="xs" key={event.id}>
          <Box sx={{ whiteSpace: 'pre-wrap' }}>
            <Typography variant="body1">{event.description}</Typography>
          </Box>
          <div>
            <Typography variant="body2" color="textSecondary">
              {moment(event.eventDate).format('LLL')} • {event.location}
            </Typography>
          </div>
        </Spacings.Stack>
      ))}
    </Spacings.Stack>
  );
};
